import axios from "axios"

import { API } from "@/utils/http"

export default {
  async citySearch({ city = "", executor = () => {} } = {}) {
    const CancelToken = axios.CancelToken
    const params = { name: city }
    const response = await API.get(`/v2/storefront/deliveries/cities`, {
      params,
      cancelToken: new CancelToken(executor)
    })

    return response
  }
}
